import React, { memo } from "react";

const colorMap = {
  "concern-hazard": "#972600",
  "concern-recommendation": "#FF8B6A",
  "concern-maintenance": "#476177",
  general: "#EDEDED",
};

const Circle = ({ type, text = null, smallTopMargin = true }) => {
  // const color = colorMap[type];

  const circleStyles = {
    width: text ? "28px" : "16px", // Make circle bigger if there's text
    height: text ? "28px" : "16px",
    minWidth: text ? "28px" : "16px", // Prevent shrinking
    backgroundColor: colorMap["general"],
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#62748E", // Text color
    fontSize: "14px", // Adjust text size as needed
    fontWeight: "bold", // Optional: make text bold,
    marginTop: smallTopMargin ? "0px" : "10px",
    flexShrink: 0, // Prevent compression in flex containers
  };

  return (
    <div className="circle" style={circleStyles}>
      {text}
    </div>
  );
};

export default memo(Circle);
